import { announcementsHandlers } from './handlers/announcements';
import { authorizationsHandlers } from './handlers/authorizations';
import { bankStatementsHandlers } from './handlers/bank-statements';
import { billingHandlers } from './handlers/billing';
import { catchallHandlers } from './handlers/catchall';
import { groupsHandlers } from './handlers/groups';
import { locationsHandlers } from './handlers/locations';
import { membersHandlers } from './handlers/members';
import { modulesHandlers } from './handlers/modules';
import { paymentsHandlers } from './handlers/payments';
import { schedulesHandlers } from './handlers/schedules';
import { sessionsHandlers } from './handlers/sessions';
import { tenantPublicHandlers } from './handlers/tenant-public';
import { upcomingCalendarHandlers } from './handlers/upcoming-calendar';
import type { HandlerEntry } from './handler-registry';

export const allDemoHandlers: readonly HandlerEntry[] = [
  ...tenantPublicHandlers,
  ...authorizationsHandlers,
  ...announcementsHandlers,
  ...membersHandlers,
  ...modulesHandlers,
  ...locationsHandlers,
  ...groupsHandlers,
  ...schedulesHandlers,
  ...sessionsHandlers,
  ...paymentsHandlers,
  ...bankStatementsHandlers,
  ...upcomingCalendarHandlers,
  ...billingHandlers,
  ...catchallHandlers,
];
